'use client';

/**
 * Prepare app for notifications
 *
 * @packageDocumentation
 * @category Component
 */

import 'BomdisoftComponents/notifications/snackbars/styles.css';
import { Offline } from 'BomdisoftComponents/notifications/offline';
import { groupSnackbarsByAnchor } from 'BomdisoftComponents/notifications/snackbars/queue';
import { Snack } from 'BomdisoftComponents/notifications/snackbars/snack';
import { useSnackbarStore } from 'BomdisoftComponents/notifications/snackbars/store';
import type { ReactNode } from 'react';

export type NotificationProviderProps = {
  children: ReactNode;
};

export const NotificationProvider = ({ children }: NotificationProviderProps) => {
  const items = useSnackbarStore(store => store.items);
  const close = useSnackbarStore(store => store.close);

  return (
    <>
      {groupSnackbarsByAnchor(items).map(region => (
        <div className='bomdisoft-snackbars-region' data-anchor={region.anchor} key={region.anchor}>
          {region.items.map(item => (
            <Snack item={item} key={item.id} onClose={close} />
          ))}
        </div>
      ))}
      <Offline />
      {children}
    </>
  );
};
